__turbopack_context__.v({
  "copyright_section": "styles-module-scss-module__nz91eG__copyright_section",
  "results_header": "styles-module-scss-module__nz91eG__results_header",
  "results_info_and_sorting_container": "styles-module-scss-module__nz91eG__results_info_and_sorting_container",
  "zero_state": "styles-module-scss-module__nz91eG__zero_state",
});
